import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';

export type ActionLabel = {key: string; module: string; params?: string[]};

@Component({
    selector: 'app-action-button',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        <button
            [type]="type()"
            class="btn d-inline-flex align-items-center gap-2 btn-{{ variant() }}"
            [class.btn-sm]="size() === 'sm'"
            [disabled]="disabled()"
            (click)="run.emit()">
            @if (busy()) {
                <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"></span>
            } @else if (icon() !== null) {
                <i class="bi {{ icon() }}" aria-hidden="true"></i>
            }
            {{ label().key | translate: 'online' : label().module : label().params }}
        </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionButtonComponent {
    readonly label = input.required<ActionLabel>();
    readonly variant = input<'primary' | 'outline-primary'>('primary');
    readonly size = input<'sm' | null>(null);
    readonly type = input<'button' | 'submit'>('button');
    readonly icon = input<string | null>(null);
    readonly busy = input(false);
    readonly disabled = input(false);
    readonly run = output<void>();
}
